import request from './request'
// ----------------------------------------------新的登录
// 账号密码登录
export const loginFn = (data) => {
  return request({ url: '/system/login', data, method: 'post' })
}
// 获取验证码
export const getmobile = (id) => {
  return request({ url: `system/SendCode/${id}`, method: 'post' })
}
// 验证码登录
export const mobileloginFn = (userPhone, code) => {
  return request({
    url: 'system/PhoneLogin',
    params: { userPhone: userPhone, code: code },
    method: 'post',
  })
}
export const getlist = () => {
  return request({ url: 'system/user/schoolList', method: 'get' })
}
// 学号获取用户信息
export const getuserInfobyId = (id) => {
  return request({ url: `/system/user/info/admin/${id}`, method: 'get' })
}
// 获取用户信息
export const getuser = () => {
  return request({ url: `/system/getInfo`, method: 'get' })
}
// 退出登录
export const outlogin = () => {
  return request({ url: `/system/logout`, method: 'delete' })
}
// 用户注册
export const registerFn = (data) => {
  return request({ url: `/system/register`, data, method: 'post' })
}
// 修改用户信息
export const edituser = (data) => {
  return request({
    url: `/system/user/profile/updatexinxi`,
    data,
    method: 'post',
  })
}
// 修改密码
export const updataPassword = (params) => {
  return request({
    url: `/classspace/updataUser/updataPassword`,
    params,
    method: 'post',
  })
}
// 上传头像
export const insertAvatar = (data) => {
  return request({
    url: `/system/user/profile/updatexinxi`,
    data,
    method: 'post',
  })
}
